module.exports = __webpack_public_path__ + "static/img/mbbj_jcjg_icon.png";